export default __webpack_public_path__ + "static/media/add-round.79341f31.svg";